import ApplicationSerializer from 'eflex/serializers/application';

export default class KineticOperationSerializer extends ApplicationSerializer {
  attrs = {
    tasks: {
      deserialize: false,
      serialize: false,
    },
    materials: {
      embedded: 'always',
    },
  };
}
